import { useEffect, useRef, useState } from 'react';
import TextIconOptionTile from '../../common/action-tile/TextIconOptionTile';
import NavHeader from '../../common/NavHeader/NavHeader';
import TextInput from '../../common/TextInput';
import SectionHeader from '../../common/typography/SectionHeader';
import CustomContainer from '../../common/wrapper/Container';
import VerticalStack from '../../common/wrapper/VerticalStack';
import CustomeHeading from '../../customeHeading/customeHeading';
import CompleteBookingWarning from './CompleteBookingWarning';
import { BOOKING_LINK_STEP } from './constants';
import { ReactComponent as PayFullIcon } from '../../../images/icons/bl-pay-full-icon.svg';
import { ReactComponent as PayDepositIcon } from '../../../images/icons/bl-pay-deposit-icon.svg.svg';
import { ReactComponent as PayMonthlyIcon } from '../../../images/icons/bl-pay-monthly-icon.svg.svg';
import { ReactComponent as DeleteIcon } from '../../../images/icons/bl-delete-icon.svg';
import { isSafariBrowser, pounds } from '../../../utils/general';
import classes from './booking-link.module.scss';
import React from 'react';
import { toastV2 } from '../../common/CustomToast/toastV2';
import { GetRyftPaymentToken } from '../../redux/actions/treatmentBooking/createTreatmentBooking';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { frontendURL } from '../../../config';
import CancellationPolicyInfo from './CancellationPolicyInfo';
import RyftComponent from '../../ryft/RyftComponent';
import { CompletePaymentBooking } from '../../redux/actions/completePaymentBooking/CompletePaymentBooking';
import { StripeComponent } from '../../Stripe/StripeComponent';
import PayLater from '../../payl8r/PayLater';
import StepButton from '../../common/StepButton';
import { PayLaterRequest } from '../../redux/actions/pay-later/PayLater';
import FlexBetweenItem from '../../common/layout/FlexBetweenItem';
import { AppText } from '../../common/typography/app-text';
import AppDivider from '../../common/layout/AppDivider';
import moment from 'moment';
import { APP_COMPONENT_SIZE, FACES_COMMISSION_AMT } from '../../../utils/constants';
import IconButton from '../../common/icon-button/IconButton';
import DiscountModal from './DiscountModal';
import ActionModal from '../../modal/ActionModal/ActionModal';
import Skeleton from 'react-loading-skeleton';

// we will generate client secret before getting card details in safari only
const shallGenerateClientSecretAfterCardDetails = !isSafariBrowser();

function EnterClientDetails({
    setStep,
    selectedTeamMember,
    selectedLocation,
    setYourDetails,
    yourDetails,
    setValidationErrors,
    validationErrors,
    paymentOptionError,
    selectedPaymentOption,
    handlePaymentOptionChange,
    totalDeposit,
    grandTotal,
    bookingId,
    onClientDetailsChange,
    payl8rData,
    callPayl8rApi,
    selectedTreatment,
    formatedDate,
    selectedTimes,
    totalPrice,
    discountValue,
    clinicId,
    handleRemoveDiscount,
    isSprintApiLoading,
    ClinicSlug
}) {
    const { slug } = useParams();
    const navigate = useNavigate();
    const paymentOptionsRef = useRef(null);
    const paymentSummaryLoaderRef = useRef(null);
    const [openPayLater, setOpenPayLater] = useState(false);
    const [payLaterData, setPayLaterData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [isDiscountOpen, setIsDiscountOpen] = useState(false);
    const [isRemoveDiscountOpen, setIsRemoveDiscountOpen] = useState(false);

    const { businessClinicList } = useSelector((state) => state?.businessLocationListReducer);
    const sessionToken = useSelector(
        (state) => state?.treatmentBookingreducer?.treatmentBookingToken
    );
    const { sprintBookingDetails } = useSelector(
        (state) => state?.getSprintBookingLinkDetailsReducer
    );

    const { initRyftPaymentToken, generateRyftToken } = GetRyftPaymentToken();
    const { initiateCompletePaymentBooking } = CompletePaymentBooking();
    const { initiatePayLaterRequest } = PayLaterRequest();

    const getRyftPaymentTokenHelper = () => {
        let isBypass =
            selectedPaymentOption === 'Split payment' && totalDeposit === 0 ? true : false;

        if (
            businessClinicList?.is_ryft_setup &&
            !isBypass &&
            (selectedPaymentOption == 'Pay in full' ||
                selectedPaymentOption == 'Split payment' ||
                selectedPaymentOption == 'Pay on the day')
        ) {
            if (shallGenerateClientSecretAfterCardDetails) {
                return;
            }

            initRyftPaymentToken(
                {
                    bookingId: bookingId,
                    paymentType: 1,
                    redirectURL: `${frontendURL}/bookings/${slug}/success`,
                    // selectedPayment: selectedPaymentOption == "Pay in full" ? "PAY_In_FULL" : "PAY_DEPOSIT"
                    saveRyftCardFlag: true,
                    selectedPayment:
                        selectedPaymentOption === 'Split payment'
                            ? 'PAY_DEPOSIT'
                            : selectedPaymentOption === 'Pay in full'
                            ? 'PAY_In_FULL'
                            : selectedPaymentOption === 'Pay on the day'
                            ? 'PAY_ON_THE_DAY'
                            : null,
                },
                (res) => {
                    // setLoader(false);
                    if (res?.data?.getRyftPaymentToken?.success) {
                        // setIsOpenPayment(true)
                    } else {
                        // setIsOpenPayment(false)
                    }
                }
            );
        } else if (
            businessClinicList?.is_stripe_setup &&
            !isBypass &&
            (selectedPaymentOption == 'Pay in full' || selectedPaymentOption == 'Split payment')
        ) {
            initRyftPaymentToken(
                {
                    bookingId: bookingId,
                    paymentType: 2,
                    redirectURL: `${frontendURL}/bookings/${slug}/success`,
                    selectedPayment:
                        selectedPaymentOption == 'Pay in full' ? 'PAY_In_FULL' : 'PAY_DEPOSIT',
                },
                (res) => {
                    // setLoader(false);
                    if (res?.data?.getRyftPaymentToken?.success) {
                        // setIsOpenPayment(true)
                    } else {
                        // setIsOpenPayment(false)
                    }
                }
            );
        }
    };

    const handlePayOnTheDay = () => {
        setLoader(true);
        if (selectedPaymentOption === 'Monthly payments') {
            initRyftPaymentToken(
                {
                    bookingId: bookingId,
                    redirectURL: `${frontendURL}/bookings/${slug}/success`,
                    selectedPayment: 'PAY_MONTHLY',
                },
                (res) => {
                    setLoader(false);
                    if (res?.data?.getRyftPaymentToken?.success) {
                        initiatePayLaterRequest(
                            {
                                bookingId: bookingId,
                                redirectURL: `${frontendURL}/bookings/${slug}/success`,
                            },
                            (res) => {
                                setLoader(false);
                                if (res.success) {
                                    setOpenPayLater(true);
                                    setPayLaterData(res?.data);
                                } else {
                                    setOpenPayLater(false);
                                    setPayLaterData(null);
                                }
                            },
                            (e) => {
                                setLoader(false);
                                toastV2(e.message);
                            }
                        );
                    } else {
                        // setIsOpenPayment(false)
                    }
                }
            );
        } else {
            initiateCompletePaymentBooking(
                {
                    bookingId: bookingId,
                    selectedPayment: 'PAY_ON_THE_DAY',
                },
                (res) => {
                    if (res.success) {
                        setLoader(false);
                        navigate(`/bookings/${slug}/success?bookingId=${bookingId}&clinicSlug=${ClinicSlug}`);
                    } else {
                        toastV2(res?.message);
                        setLoader(false);
                    }
                },
                (e) => {
                    toastV2(e.message);
                    setLoader(false);
                }
            );
        }
    };

    useEffect(() => {
        callPayl8rApi();
    }, [discountValue]);

    useEffect(() => {
        if (selectedPaymentOption && paymentOptionsRef.current && !isSprintApiLoading) {
            paymentOptionsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (selectedPaymentOption && paymentSummaryLoaderRef.current) {
            paymentSummaryLoaderRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [selectedPaymentOption, isSprintApiLoading]);

    useEffect(() => {
        if (bookingId && selectedPaymentOption && businessClinicList) {
            getRyftPaymentTokenHelper();
        }
    }, [bookingId, selectedPaymentOption, businessClinicList]);

    const generateRyftTokenHelper = async () => {
        const token = await generateRyftToken({
            bookingId: bookingId,
            paymentType: 1,
            redirectURL: `${frontendURL}/bookings/${slug}/success`,
            saveRyftCardFlag: true,
            selectedPayment:
                selectedPaymentOption === 'Split payment'
                    ? 'PAY_DEPOSIT'
                    : selectedPaymentOption === 'Pay in full'
                    ? 'PAY_In_FULL'
                    : selectedPaymentOption === 'Pay on the day'
                    ? 'PAY_ON_THE_DAY'
                    : null,
        });

        return token;
    };

    const bookingSuccessCallBack = (data) => {
        if (data?.status === 'Approved' || data?.status === 'Captured') {
            initiateCompletePaymentBooking(
                {
                    bookingId: bookingId,
                    paymentId: data.id,
                    paymentType: 1,
                    isCardToken: selectedPaymentOption === 'Pay on the day',
                    selectedPayment:
                        selectedPaymentOption == 'Pay in full'
                            ? 'PAY_In_FULL'
                            : selectedPaymentOption === 'Split payment'
                            ? 'PAY_DEPOSIT'
                            : selectedPaymentOption === 'Pay on the day'
                            ? 'PAY_ON_THE_DAY'
                            : null,
                },
                (res) => {
                    if (res.success) {
                        navigate(`/bookings/${slug}/success?bookingId=${bookingId}&ps=${data.id}&clinicSlug=${ClinicSlug}`);
                    } else {
                        navigate(`/bookings/${slug}/fail?bookingId=${bookingId}&ps=${data.id}&clinicSlug=${ClinicSlug}`);
                    }
                },
                (e) => {
                    navigate(`/bookings/${slug}/fail?bookingId=${bookingId}&ps=${data.id}&clinicSlug=${ClinicSlug}`);
                }
            );
        } else {
            navigate(`/bookings/${slug}/fail?bookingId=${bookingId}&ps=${data.id}&clinicSlug=${ClinicSlug}`);
        }
    };

    const handleDetailsChange = (e) => {
        const { name, value } = e.target;
        if (value !== '') {
            setValidationErrors((prev) => ({ ...prev, [name]: '' }));
        }

        onClientDetailsChange();
        setYourDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const isPaymentGatewayConnected = () => {
        return businessClinicList?.is_stripe_setup || businessClinicList?.is_ryft_setup;
    };

    const shallRenderRyftComponent = () => {
        if (!businessClinicList?.is_ryft_setup) {
            return false;
        }
        if (selectedPaymentOption === 'Pay on the day') {
            return businessClinicList?.want_client_card_details_for_pod;
        }

        return selectedPaymentOption !== 'Monthly payments';
    };

    // booking fees calculation
    const getBookingFees = () => {
        if (!businessClinicList?.is_ryft_setup || !sprintBookingDetails?.paymentSummary?.processingFeeBearer) {
            return 0;
        }
        if (selectedPaymentOption !== 'Split payment' && selectedPaymentOption !== 'Pay in full') {
            return 0;
        }
        let basePrice = 0;

        if (selectedPaymentOption === 'Split payment') {
            basePrice = totalDeposit;
        }
        if (selectedPaymentOption === 'Pay in full') {
            basePrice = grandTotal;
        }
        const commissionPercentage =
            sprintBookingDetails?.paymentSummary?.commissionPercentage || 0;
        let bookingCommision = (basePrice / 100) * commissionPercentage;
        if (bookingCommision > 0) {
            bookingCommision = bookingCommision + FACES_COMMISSION_AMT;
        }
        return bookingCommision;
    };

    const getPayableAmount = () => {
        if (selectedPaymentOption === 'Pay on the day') {
            return 0;
        }

        if (selectedPaymentOption === 'Split payment') {
            return totalDeposit + Number(getBookingFees().toFixed(2));
        }
        return grandTotal + Number(getBookingFees().toFixed(2));
    };

    return (
        <CustomContainer removeTopPadding>
            {!openPayLater && (
                <VerticalStack addBottomPadding>
                    <NavHeader
                        isSticky
                        isBackOnly
                        handleOnBack={() => setStep(BOOKING_LINK_STEP.TEAM_MEMBER)}
                    />
                    <CompleteBookingWarning />
                    <div className='ReviewAndConfirmForm'>

                    <CustomeHeading
                        Title="Review and confirm"
                        Desc={`Please review and confirm the booking with ${selectedTeamMember?.name} at ${selectedLocation?.clinic_name}`}
                    />

                    {/* Client details */}
                        <SectionHeader size={APP_COMPONENT_SIZE.medium} title="Your details" />
                        <VerticalStack space={20}>
                            <TextInput
                                size={APP_COMPONENT_SIZE.small}
                                error={validationErrors?.clientFName}
                                label="First name"
                                placeholder="First name"
                                value={yourDetails?.clientFName}
                                name="clientFName"
                                id="firstname"
                                onChange={handleDetailsChange}
                            />
                            <TextInput
                                size={APP_COMPONENT_SIZE.small}
                                error={validationErrors?.clientLName}
                                label="Last name"
                                placeholder="Last name"
                                value={yourDetails?.clientLName}
                                name="clientLName"
                                id="lastname"
                                onChange={handleDetailsChange}
                            />
                            <TextInput
                                size={APP_COMPONENT_SIZE.small}
                                error={validationErrors?.clientEmail}
                                label="Email address"
                                placeholder="Email address"
                                value={yourDetails?.clientEmail}
                                name="clientEmail"
                                onChange={handleDetailsChange}
                            />
                        </VerticalStack>
                    </div>

                    {/* Payment options */}
                    <div>
                        <SectionHeader size={APP_COMPONENT_SIZE.medium} title="Payment options" />
                        <VerticalStack space={20}>
                            {isPaymentGatewayConnected() && (
                                <TextIconOptionTile
                                    size={APP_COMPONENT_SIZE.medium}
                                    icon={<PayFullIcon />}
                                    title={'Pay in full'}
                                    subtitle={`Pay the full ${pounds.format(grandTotal)} now.`}
                                    checked={selectedPaymentOption === 'Pay in full'}
                                    onChange={() => handlePaymentOptionChange('Pay in full')}
                                />
                            )}
                            {isPaymentGatewayConnected() &&
                                totalDeposit >= 1.2 &&
                                grandTotal >= totalDeposit && (
                                    <TextIconOptionTile
                                        size={APP_COMPONENT_SIZE.medium}
                                        icon={<PayDepositIcon />}
                                        title="Pay deposit"
                                        subtitle={`${pounds.format(
                                            totalDeposit
                                        )} now, ${pounds.format(
                                            grandTotal - totalDeposit
                                        )} on the day.`}
                                        onChange={() => handlePaymentOptionChange('Split payment')}
                                        checked={selectedPaymentOption === 'Split payment'}
                                    />
                                )}
                            {(!isPaymentGatewayConnected() || totalDeposit === 0) && (
                                <TextIconOptionTile
                                    size={APP_COMPONENT_SIZE.medium}
                                    icon={<PayMonthlyIcon />}
                                    title="Pay on the day"
                                    subtitle={'Pay the full amount in the venue'}
                                    onChange={() => handlePaymentOptionChange('Pay on the day')}
                                    checked={selectedPaymentOption === 'Pay on the day'}
                                />
                            )}
                            {businessClinicList?.is_finance_available && grandTotal >= 50 && (
                                <TextIconOptionTile
                                    size={APP_COMPONENT_SIZE.medium}
                                    icon={<PayMonthlyIcon />}
                                    title="Pay monthly"
                                    subtitle={`3 payments of £${payl8rData?.['3Month']?.monthlyPaymentAmount} with Payl8r`}
                                    onChange={() => handlePaymentOptionChange('Monthly payments')}
                                    checked={selectedPaymentOption === 'Monthly payments'}
                                />
                            )}
                            {paymentOptionError && <p className="error">{paymentOptionError}</p>}
                        </VerticalStack>
                    </div>

                    {selectedPaymentOption && isSprintApiLoading && (
                        <>
                            <div ref={paymentSummaryLoaderRef}>
                                <Skeleton
                                    height={20}
                                    borderRadius={6}
                                    style={{ marginBottom: '15px' }}
                                />
                                <Skeleton height={223} borderRadius={10} />
                            </div>
                            <div>
                                <Skeleton
                                    height={20}
                                    borderRadius={6}
                                    style={{ marginBottom: '15px' }}
                                />
                                <Skeleton height={81} borderRadius={20} />
                            </div>
                            <div>
                                <Skeleton height={70} borderRadius={8} />
                            </div>
                        </>
                    )}

                    {selectedPaymentOption && !isSprintApiLoading && (
                        <>
                            {/* Payment summary */}
                            <div ref={paymentOptionsRef}>
                                <SectionHeader
                                    size={APP_COMPONENT_SIZE.medium}
                                    title="Payment summary"
                                />
                                <div className={classes.paymentSummaryBox}>
                                    <VerticalStack space={10}>
                                        {selectedTreatment.map((item, index) => (
                                            <>
                                                <FlexBetweenItem key={index}>
                                                    <AppText weight="600" font="small" dark>
                                                        {item.name}
                                                    </AppText>
                                                    <AppText font="small" dark>
                                                        {pounds.format(item?.amount)}
                                                    </AppText>
                                                </FlexBetweenItem>
                                                <AppDivider />
                                            </>
                                        ))}
                                        <FlexBetweenItem>
                                            <AppText weight="600" font="small" dark>
                                                Date
                                            </AppText>
                                            <AppText font="small" dark>
                                                {moment(formatedDate, 'Do MMMM YYYY').format(
                                                    'Do MMM YYYY'
                                                )}
                                            </AppText>
                                        </FlexBetweenItem>
                                        <AppDivider />
                                        <FlexBetweenItem>
                                            <AppText weight="600" font="small" dark>
                                                Time
                                            </AppText>
                                            <AppText font="small" dark>
                                                {selectedTimes}
                                            </AppText>
                                        </FlexBetweenItem>
                                        <AppDivider />

                                        {/* mobile device discount */}
                                        <FlexBetweenItem className={classes.onlyMobile}>
                                            <AppText
                                                onClick={() => {
                                                    if (!selectedPaymentOption) {
                                                        toastV2(
                                                            'You can apply the discount after selecting the payment method'
                                                        );
                                                    } else if (discountValue === 0) {
                                                        setIsDiscountOpen(true);
                                                    }
                                                }}
                                                weight="600"
                                                font="small"
                                                dark
                                                className={
                                                    discountValue === 0 &&
                                                    'text-decoration-underline cursor-pointer'
                                                }
                                            >
                                                {discountValue === 0
                                                    ? 'Apply discount'
                                                    : 'Applied discount'}
                                            </AppText>
                                            <div className={classes.discountPriceWrapper}>
                                                <AppText font="small" dark>
                                                    {pounds.format(discountValue)}
                                                </AppText>
                                                {discountValue > 0 && (
                                                    <IconButton
                                                        onClick={() =>
                                                            setIsRemoveDiscountOpen(true)
                                                        }
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                )}
                                            </div>
                                        </FlexBetweenItem>
                                        <AppDivider className={classes.onlyMobile} />

                                        {/* bearer booking fees */}
                                        {getBookingFees() > 0 && (
                                            <>
                                                <FlexBetweenItem>
                                                    <AppText weight="600" font="small" dark>
                                                        Booking fees
                                                    </AppText>
                                                    <AppText font="small" dark>
                                                        {pounds.format(getBookingFees())}
                                                    </AppText>
                                                </FlexBetweenItem>
                                                <AppDivider />
                                            </>
                                        )}

                                        {/* total payable amount */}
                                        <FlexBetweenItem>
                                            <AppText weight="600" font="small" dark>
                                                Payable amount
                                            </AppText>
                                            <AppText font="small" dark>
                                                {pounds.format(getPayableAmount())}
                                            </AppText>
                                        </FlexBetweenItem>
                                    </VerticalStack>
                                </div>
                            </div>

                            {/* Card details */}
                            <div className="stripe-checkout-main-div stripe-checkout-main-div-new-design">
                                {shallRenderRyftComponent() && (
                                    <SectionHeader
                                        size={APP_COMPONENT_SIZE.medium}
                                        title="Secure your booking"
                                    />
                                )}
                                <VerticalStack>
                                    {shallRenderRyftComponent() && <CancellationPolicyInfo />}
                                    {shallRenderRyftComponent() ? (
                                        <RyftComponent
                                            setIsOpenPayment={() => {
                                                window.location.reload();
                                            }}
                                            clientSecret={
                                                shallGenerateClientSecretAfterCardDetails
                                                    ? null
                                                    : sessionToken
                                            }
                                            {...(shallGenerateClientSecretAfterCardDetails && {
                                                generateClientSecret: generateRyftTokenHelper,
                                            })}
                                            waitForClientSecret={
                                                !shallGenerateClientSecretAfterCardDetails
                                            }
                                            successCallback={bookingSuccessCallBack}
                                            selectedPaymentOption={selectedPaymentOption}
                                        />
                                    ) : (
                                        (selectedPaymentOption === 'Pay in full' ||
                                            selectedPaymentOption === 'Split payment') &&
                                        businessClinicList?.is_stripe_setup && (
                                            <StripeComponent
                                                setIsOpenPayment={() => {
                                                    window.location.reload();
                                                }}
                                                clientSecret={sessionToken}
                                                paymentType="card"
                                                bookingId={bookingId}
                                                selectedPaymentOption={selectedPaymentOption}
                                            />
                                        )
                                    )}
                                    {(selectedPaymentOption === 'Monthly payments' ||
                                        (selectedPaymentOption === 'Pay on the day' &&
                                            (!businessClinicList?.is_ryft_setup ||
                                                !businessClinicList?.want_client_card_details_for_pod))) && (
                                        <StepButton
                                            blue={true}
                                            label={
                                                selectedPaymentOption === 'Monthly payments'
                                                    ? 'Complete booking'
                                                    : 'Confirm'
                                            }
                                            onClick={() => handlePayOnTheDay()}
                                            isLoading={loader}
                                        />
                                    )}
                                </VerticalStack>
                            </div>
                        </>
                    )}
                </VerticalStack>
            )}
            {openPayLater && (
                <PayLater
                    payLaterData={payLaterData}
                    bookingId={bookingId}
                    setOpenPayLater={setOpenPayLater}
                />
            )}
            <DiscountModal
                isOpen={isDiscountOpen}
                setIsOpen={setIsDiscountOpen}
                clinicId={clinicId}
            />
            <ActionModal
                title="Are you sure"
                desc="you want to delete this discount code?"
                onlyAction
                onAction={() => {
                    handleRemoveDiscount();
                    setIsRemoveDiscountOpen(false);
                }}
                actionText="Ok"
                onClose={() => setIsRemoveDiscountOpen(false)}
                open={isRemoveDiscountOpen}
            />
        </CustomContainer>
    );
}
export default EnterClientDetails;
